export default "__VITE_ASSET__47a241b7__"